const LoadingPost = () => {
  return (
    <div className="w-full rounded-md border-2 border-gray-600 p-4 opacity-50 shadow">
      <div className="flex animate-pulse space-x-4">
        <div className="h-36 w-36 rounded bg-gray-600" />
        <div className="flex flex-1 flex-col justify-between py-1">
          <div className="felx flec-col space-y-6">
            <div className="h-2 rounded bg-gray-600" />
            <div className="h-2 max-w-sm rounded bg-gray-600" />
            <div className="h-2 max-w-xs rounded bg-gray-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

const FeedPostsLoading = () => {
  return (
    <div className="min-h-screen w-full space-y-4 pt-4">
      <LoadingPost />
      <LoadingPost />
      <LoadingPost />
      <LoadingPost />
    </div>
  );
};

export default FeedPostsLoading;
